import { UserRoles, CreateUserParams, UserPermissions } from 'entities/User';
import { StepData, stepsMapper } from 'features/Stepper';

export enum CreateUserSteps {
  ACCOUNT_DETAILS = 'Account Details',
  CHOOSE_WAREHOUSE = 'Choose Warehouse',
  CHOOSE_PERMISSION = 'Choose Permission',
}

export const createUserSteps = stepsMapper([...Object.values(CreateUserSteps)]);

export interface CreateUserModalSchema {
  isOpened: boolean;
  steps: StepData[];
  selectedRole: Nullable<UserRoles>;
  userData: Nullable<CreateUserParams>;
  selectedWarehouses: string[];
  selectedPermissions: UserPermissions[];
}

export interface WarehouseListFilters {
  franchiseId: string;
}

export enum WarehouseListFilterKeys {
  franchiseId = 'franchiseId',
}
